<template>
  <div>
    <v-subheader key="subheader">Autorizaciones de tutores</v-subheader>
    <v-list-tile avatar v-for="(parent, key) in notice.parentsConfirmed" :key="key" class="mb-3">
      <v-list-tile-avatar>
        <img v-if="parent.image" :src="'data:image/jpg;base64, ' +parent.image" />
        <v-icon v-else color="gray lighten-4">account_circle</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-text="parent.firstName + ' ' + parent.lastName"></v-list-tile-title>
        <v-list-tile-sub-title>{{ parent.noticeConfirm | parentConfirmFilter }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </div>
</template>

<script>
export default {
  props: ["notice"],
  filters: {
    parentConfirmFilter: function(status) {
      switch (status) {
        case "A":
          return "Autorizado";
        case "C":
          return "Cancelado";
        case "P":
          return "Pendiente";
        case "D":
          return "Eliminado";
        case "U":
          return "Actualizado";
        default:
          return "No determinado";
      }
    }
  }
};
</script>